'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconCircleSlash, iconCircleSlashTag } from '@ni/nimble-components/dist/esm/icons/circle-slash';
import { wrap } from '../../utilities/react-wrapper';

export type { IconCircleSlash };
export { iconCircleSlashTag };
export const NimbleIconCircleSlash = wrap(IconCircleSlash);